var BaseBarSeries = require("./BaseBarSeries");

var _default = BaseBarSeries.extend({
  type: 'series.bar',
  dependencies: ['grid', 'polar'],
  brushSelector: 'rect'
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/chart/bar/BarSeries.js
// module id = 2023
// module chunks = 1